import { TimezoneEnum } from '../../dataAccess/dto'

export const TIME_ZONE = (Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Europe/Madrid') as TimezoneEnum